import React from 'react'
import { useWorkOrderListContext } from './Context'
import type { DataTableProps } from '@ztechapps/webui.data-tools'
import { DataTable } from '@ztechapps/webui.data-tools'
import { workOrderListFieldConfig as fieldsCore } from './constants'
import { ListRow } from './ListRow'
import { ListHeader } from './ListHeader'
import { WorkOrderTreeTableBody } from './WorkOrderTreeTableBody'
import type { SetOptional } from 'type-fest'
import type { WorkOrder } from '@ztechapps/common.contract'

export const WorkOrderList = ({
  row,
  head,
  fields,
  listResult,
  tableOptions,
  components,
  ...props
}: SetOptional<DataTableProps<WorkOrder>, 'listResult' | 'fields'>) => {
  const { workOrderList } = useWorkOrderListContext()

  return (
    <DataTable
      fields={fields ?? fieldsCore}
      listResult={listResult ?? workOrderList}
      row={row ?? ListRow}
      head={head ?? ListHeader}
      tableOptions={{
        ...tableOptions,
        responsive: true,
      }}
      components={{
        tableBody: WorkOrderTreeTableBody,
        ...components,
      }}
      stats={'productions'}
      {...props}
    />
  )
}
